// extracted by mini-css-extract-plugin
module.exports = {"bankLogo":"CheckingAccountSummary-module__bankLogo___ibNB9","checkingSummary":"CheckingAccountSummary-module__checkingSummary___3P5Ui"};